import { api, type Page } from "@/lib/api/client";
import type {
  Announcement,
  AnnouncementCreateInput,
  AnnouncementFilters,
  AnnouncementUpdateInput,
  Notification,
  NotificationFilters,
  UnreadCount,
} from "./notifications.types";

const BASE = "/notifications";
const ANNOUNCEMENTS = "/notifications/announcements";

export const notificationsApi = {
  list(filters: NotificationFilters): Promise<Page<Notification>> {
    return api.page<Notification>(BASE, { params: { ...filters } });
  },

  unreadCount(): Promise<UnreadCount> {
    return api.get<UnreadCount>(`${BASE}/unread-count`);
  },

  markRead(id: string): Promise<Notification> {
    // Okundu işareti kişinin kendi durumu: zilden basılınca arkadaki ekranı yeniden çekmesin.
    return api.post<Notification>(`${BASE}/${id}/read`, {}, { quiet: true });
  },

  markAllRead(): Promise<{ updated: number }> {
    return api.post(`${BASE}/read-all`, {}, { quiet: true });
  },

  /**
   * What the CALLER should see right now — window open, audience matched.
   *
   * A separate route from the managed list, and not a filter on it: this one is readable with
   * the plain notification permission because everybody reads announcements, while the managed
   * list needs the manage key. One endpoint with a flag would have to be the more permissive
   * of the two.
   */
  activeAnnouncements(): Promise<Announcement[]> {
    return api.get<Announcement[]>(`${ANNOUNCEMENTS}/active`);
  },

  announcements(filters: AnnouncementFilters): Promise<Page<Announcement>> {
    return api.page<Announcement>(ANNOUNCEMENTS, { params: { ...filters } });
  },

  createAnnouncement(input: AnnouncementCreateInput): Promise<Announcement> {
    return api.post<Announcement>(ANNOUNCEMENTS, input);
  },

  updateAnnouncement(id: string, input: AnnouncementUpdateInput): Promise<Announcement> {
    return api.patch<Announcement>(`${ANNOUNCEMENTS}/${id}`, input);
  },

  removeAnnouncement(id: string, version?: number): Promise<void> {
    return api.delete(`${ANNOUNCEMENTS}/${id}`, {
      ...(version === undefined ? {} : { params: { version } }),
    });
  },
};
